import routes from "./routes";

export const SIDEBAR_ITEMS = [
  {
    id: "packages",
    label: "Packages",
    iconName: "inventory",
    path: routes.packages.root,
    match: (pathname) => pathname === routes.packages.root,
  },
  {
    id: "coupons",
    label: "Coupons",
    iconName: "localOffer",
    path: routes.coupons.list,
    match: (pathname) => pathname.startsWith("/coupons"),
  },
  {
    id: "uploads",
    label: "Uploads",
    iconName: "cloudUpload",
    path: routes.uploads.root,
    match: (pathname) => pathname === routes.uploads.root,
  },
];
